<p-password
  [appendTo]="undefined"
  [autofocus]="autofocus()"
  [feedback]="feedback()"
  [formControl]="control()"
  [inputStyleClass]="inputStyleClass()"
  class="tw:w-full"
  [style]="undefined"
  [toggleMask]="toggleMask()"
  [tabindex]="tabindex()"
  [autocomplete]="autocomplete() ?? 'current-password'"
/>
